import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Realmente son solo 10 minutos?',
  a: 'Sí, el ritual está diseñado específicamente para la fase de inicio. Una vez que rompes la inercia inicial de 10 minutos, el cerebro entra en estado de flujo naturalmente.'
}, {
  q: '¿Necesito herramientas caras?',
  a: 'No, solo un cronómetro (incluso el de tu teléfono o de cocina) y este manual. El sistema se basa en psicología, no en software.'
}, {
  q: '¿Funciona para tareas creativas?',
  a: 'Es ideal para romper el bloqueo del lienzo en blanco. Te ayuda a superar el perfeccionismo inicial que paraliza a los creativos.'
}, {
  q: '¿Puedo leerlo en mi teléfono?',
  a: 'Sí, el PDF está 100% optimizado para ser leído cómodamente en dispositivos móviles, tablets o computadora.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-brand-card relative border-y border-white/5" data-id="element-33">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-36">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-38">
              <div className="border border-white/10 rounded-2xl overflow-hidden bg-brand-dark transition-colors hover:border-white/20" data-id="element-39">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-40">
                  <span className="text-lg font-semibold text-white pr-8" data-id="element-41">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-orange transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
                </button>
                <AnimatePresence data-id="element-43">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-44">
                      <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-45">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}